import { FlexBox } from '@dixa/lib-shared-habla';

import { SatisfactionRatingReceivedMessage } from '../components/SatisfactionRatingReceivedMessage';

type ThumbsUpOrDownRatingMessageProps = {
  /** 0 for thumbs down, 1 for thumbs up */
  score: number;
  /** The comment from the user */
  comment: string;
};

const thumbsUpIcon = '👍';
const thumbsDownIcon = '👎';

const labelsAndIconsMap = {
  0: {
    label: 'Thumbs down',
    icon: thumbsDownIcon,
  },
  1: {
    label: 'Thumbs up',
    icon: thumbsUpIcon,
  },
};

export const ThumbsUpOrDownRatingMessage = ({
  score,
  comment,
}: ThumbsUpOrDownRatingMessageProps): JSX.Element => {
  const isThumbsUp = score === 1;
  const isThumbsDown = score === 0;

  const scoreElement = labelsAndIconsMap[score]?.icon;
  const ratingLabel = labelsAndIconsMap[score]?.label ?? 'Unknown score';

  return (
    <SatisfactionRatingReceivedMessage
      scoreElement={
        <FlexBox
          justifyContent="center"
          alignItems="center"
          width="30px"
          height="30px"
          fontSize="30px"
        >
          {scoreElement}
        </FlexBox>
      }
      tooltipContent={
        isThumbsUp ? 'Thumbs up' : isThumbsDown ? 'Thumbs down' : 'Unknown'
      }
      ratingTypeLabel={ratingLabel}
      comment={comment}
    />
  );
};
